import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MenadzmentPredmetM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Menadžment" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Menadžment</h2>
              <p>
                <strong>Studijski program:</strong> Menadžment
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Menadžment
              </p>
              <p>
                <strong>Nastavnik:</strong>{" "}
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Da studentima predstavi potrebu korišćenja upravljačkih metoda i
                pristupa odnosno upotrebu menadžmenta kao naučne discipline ali
                i profesije koja se bavi upravljanjem proizvodnim i uslužnim
                organizacijama u cilju njihove uspješnosti. Takođe upoznavanje
                sa menadžmentom kao složenim procesom usmjeravanja grupe ljudi u
                izvršavanju određenih poslova i zadataka radi ostvarivanja
                unaprijed utvrđenih zajedničkih ciljeva pri čemu ovaj proces
                obuhvata više različitih potprocesa odnosno funkcija kao što su:
                planiranje organizovanje obezbjeđivanje kadrova rukovođenje
                (liderstvo) i kontrola koji omogućava praktičnu primjenu sa
                ciljem uspješnog poslovanja preduzeća.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješnog završetka ovog programskog sadržaja studenti su
                osposobljeni da u organizaciji u kojoj budu radili shvate
                osnovne procese menadžmenta uoče osnovne probleme i da ih
                rješavaju primjenom različitih metoda tehnika i vještina i
                preduzmu odgovarajuće poslovne aktivnosti kako bi se ostvarili
                postavljeni ciljevi. Takođe ovladavaju raznim vještinama:
                upravljanja vremenom sprječavanja stresa ovladavanja emocijama
                aktivnog slušanja podučavanja stvaranja efektivnih timova
                prenošenja zaduženja razvijanja povjerenja istraživanje
                poslovnog okruženja.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Uvod u menadžment; Razvoj menadžmenta i škole
                menadžmenta; Proizvodni menadžment; Menadžment malih srednjih i
                velikih preduzeća; Menadžment i menadžeri: uloga i zadaci
                menadžera aktivnosti menadžera klasifikacija menadžmenta pojam i
                uloga top menadžmenta; Vrste menadžmenta: strategijski
                operativni i menadžment poslovnih područja; Nosioci upravljačkog
                procesa (preduzetnik menadžer i lider); Funkcije menadžmenta:
                planiranje organizovanje vođenje i kontrola; Kadrovski
                menadžment; Odlučivanje u menadžmentu (pojam i faze procesa
                odlučivanja modeli i modeliranje izbor i primjena metoda i
                tehnika odlučivanja); Menadžment inovacijama i promjenama;
                Menadžment projektima; Menadžment i menadžer u budućnosti;
                Menadžment ukupnog kvaliteta.
              </p>
              <p>
                Praktična nastava je komplementarna predavanjima. Na vježbama se
                razrađuju pojmovi koji su izloženi na predavanjima obrađuju se i
                rješavaju konkretni problemi i zadaci i diskutuje o izloženim
                konceptima. Oblici rada koji se sprovode na vježbama su:
                prezentacija dopunskih informacija i primjera diskusije metode i
                tehnike u pojedinim funkcijama menadžmenta pojedinačni i grupni
                rad studenata na rješavanju primjera iz prakse prezentacija
                rješenja različiti načini provjere znanja.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja se izvode uz korišćenje prezentacija i dodatna
                objašnjenja profesora. Praktična nastava prati teorijska
                predavanja uz primjenu sledećih važnijih metoda: interaktivni
                rad pojedinačne i grupne prezentacije analiza praktičnih
                slučajeva simulacija različitih uloga.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>Uvod u menadžment</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>Razvoj menadžmenta i škole menadžmenta</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>Proizvodni menadžment</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>Menadžment malih srednjih i velikih preduzeća</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>
                      Menadžment i menadžeri: uloga i zadaci menadžera
                      aktivnosti menadžera klasifikacija menadžmenta pojam i
                      uloga top menadžmenta
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>
                      Vrste menadžmenta: strategijski operativni i menadžment
                      poslovnih područja
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Nosioci upravljačkog procesa (preduzetnik menadžer i
                      lider)
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>
                      Funkcije menadžmenta: planiranje organizovanje vođenje i
                      kontrola
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>Kadrovski menadžment</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>
                      Odlučivanje u menadžmentu (pojam i faze procesa
                      odlučivanja modeli i modeliranje izbor i primjena metoda i
                      tehnika odlučivanja)
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>Menadžment inovacijama i promjenama</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>
                      Menadžment projektima; Menadžment i menadžer u budućnosti
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>Menadžment ukupnog kvaliteta</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 430 h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 300 h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MenadzmentPredmetM;
